import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Utils } from '../utility/utils';

@Component({
	selector: 'confrm-dialog',
	templateUrl: './confirm-dialog.component.html',
	styleUrls: ['./confirm-dialog.component.css'],
})
export class ConfirmDialogComponent implements OnInit {
	public alertSize = 'large';
	public confirmed = false;
	public showSecondButton = true;
	public options = [];
	constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>, @Inject(MAT_DIALOG_DATA) public data) {}

	ngOnInit() {
		this.showSecondButton = this.data?.showSecondButton??true;
		this.options = this.data?.options;
	}

	

	disableContinueButton() {
		return this.data.confirmationMessage
			? !this.confirmed
			: this.data.textarea || this.data.showOptions
			? Utils.isEmptyCondition(this.data.reason?.trim())
			: false;
	}

	onClose() {
		this.dialogRef.close();
	}
}
